import {useEffect, useState} from "react";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading} from "../../../components/template/architecture";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {BreadCrumbs} from "../../../components/open/pages";
import {ThinPrintIcon, TomansIcon} from "../../../components/icons/material-icons";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GradeToString} from "../students/list";

export interface thoseWhoPaidInFull {
    id: number,
    name: string,
    nationalCode: string,
    grade: number,
    totalTuitionPrice: number,
    paidAmount:number,
    class:string,
}

export const AdminFinanceThoseWhoPaidFullyScreen = () => {
    const [data, setData] = useState({
        loaded: false,
        list: [] as thoseWhoPaidInFull[],
    });
    const fetchList = () => {
        PostJSON(
            Apis.server + '/core/admins/finance/who-paid-full/list',
            {},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: thoseWhoPaidInFull[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setData({
                    list: d.list === null ? [] : d.list,
                    loaded: true,
                });
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "دانش‌آموزان تسویه‌حساب شده | نهال";
        fetchList();
    }, []);
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'امور مالی', url: '/admins/finance'},
                {title: 'دانش‌آموزان تسویه‌حساب شده', url: '/admins/finance/paid-full'},
            ]}/>
            {
                data.loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>دانش‌أموزان تسویه‌حساب شده</b>
                                <button onClick={() => window.open("/print/admins/finance/paid-full")}>
                                    <ThinPrintIcon/>
                                    <span>پرینت</span>
                                </button>
                            </div>
                            <table className="table open-table table-stripped table-bordered table-hover"
                                   style={{display: 'table!important', border: 0}}>
                                <thead>
                                <tr>
                                    <th>ردیف</th>
                                    <th>دانش‌آموز</th>
                                    <th>کدملی</th>
                                    <th>کلاس</th>
                                    <th>مبلغ شهریه</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    (data.list === null ? [] : data.list).map((p, i) =>
                                        <tr key={"K39Erc1nSss" + i}>
                                            <td style={{width: '10%'}}>{StringDigitsConvertToPersian(i + 1)}</td>
                                            <td style={{width: '30%'}}>{p.name}</td>
                                            <td style={{width: '20%'}}>{StringDigitsConvertToPersian(p.nationalCode)}</td>
                                            <td style={{width: '15%'}}>{p.class === "" ? 'نامشخص' : p.class}</td>
                                            <td style={{width: '15%'}}>
                                                <span>{CurrencyFormat(p.totalTuitionPrice)}<TomansIcon/></span>
                                            </td>
                                        </tr>
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div> : null
            }
        </>
    );
};